import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { FrontOffice } from '../../models/front-office.model';
import { FrontOfficeReason } from '../../models/frontofficeReason.model';

@Injectable({ providedIn: 'root' })
export class FrontOfficesService {
    constructor(private dataService: DataService) { }

    public delete(dealerCod: string, userSSB: string) {
        return this.dataService.delete<Result<string>>('frontoffices/' + dealerCod + '/' + userSSB);
    }

    public deleteFrontOfficeReason(cod: number) {
        return this.dataService.delete<Result<string>>('frontoffices/reasons/' + cod);
    }

    public get() {
        return this.dataService.get<Result<FrontOffice>>('frontoffices');
    }

    public getByDealer(dealerCod: string) {
        return this.dataService.get<Result<FrontOffice>>('frontoffices/dealer/' + dealerCod);
    }

    public getReasons() {
        return this.dataService.get<Result<FrontOfficeReason>>('frontoffices/reasons');
    }

    public insert(frontOffice: FrontOffice) {
        return this.dataService.post<Result<FrontOffice>>('frontoffices', frontOffice);
    }

    public insertFrontOfficeReason(frontOfficeReason: FrontOfficeReason) {
        return this.dataService.post<Result<FrontOfficeReason>>('frontoffices/reasons', frontOfficeReason);
    }

    public update(frontOffice: FrontOffice) {
        return this.dataService.put<Result<FrontOffice>>('frontoffices', frontOffice);
    }
}
